<script setup lang="ts">
import ChatPanel from './ChatPanel.vue'

defineProps<{
  bandId: number
}>()
</script>

<template>
  <div class="mt-6 pt-4 rd-divider">
    <ChatPanel :band-id="bandId" label="Chat" />
  </div>
</template>
